<template>
  <b-form-group
    label="Vergi Dairesi"
    label-for="tax_office"
  >
    <validation-provider
      #default="{ errors }"
      name="Vergi Dairesi"
      rules="required"
    >
      <b-form-input
        id="tax_office"
        v-model="dataItem.tax_office"
        placeholder="Vergi Dairesi"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'TaxOffice',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['configCompany/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
